import React, {useContext, useEffect, useRef, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Button, Card, Popconfirm, Table} from "antd";
import Colors from "../../../styles/Colors";
import {BiCopy, BiInfoCircle, BiPencil, BiPlus, BiRefresh, BiTrash} from "react-icons/bi";
import Historials from "../../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye} from "react-icons/bs";
import PlantillaLista from "../../PlantillaLista";
import RebutFIltre from "../../../model/multilleure/rebuts/RebutFIltre";
import dayjs, {Dayjs} from 'dayjs';
import toast, {Toaster} from "react-hot-toast";
import {QuestionCircleOutlined} from "@ant-design/icons";
import Casal from "../../../model/inscripcions/Casal";
import CasalsModal from "./components/CasalsModal";
import {GetCasalsJson} from "../../../dao/multilleure/casals/GetCasalsJson";
import {Tour, TourProps} from "antd-v5";
import Activitat from "../../../model/multilleure/casals/Activitat";

const ConfiguracioCasals = () => {
    const titol: string = "CONFIGURACIÓ CASALS";
    const nomPermis: string = "configuraciocasals";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<Casal[]>([]);
    const [elementSelected, setElementSelected] = useState<Casal>(new Casal());
    const [loading, setLoading] = useState(false);
    const [editar, setEditar] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);

    const permisosEdicio = user.pagines.some(pagina => pagina.nom === nomPermis && pagina.tipus === 1);
    console.log(user.pagines);
    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());


    const [open, setOpen] = useState<boolean>(false);

    useEffect(() => {
        handleLoadingChange(true)
        if (isLoggedIn) {
            checkDades();
        }
    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetCasalsJson(page);
        setDades(dades);
        setNomFiltres(dades);
        handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(id: number) {
        //await DeleteIngredient(id, page);
        await checkDades();
    }

    function afegirElement(element: Casal) {
        setNouElement(!nouElement);
        setEditar(true);
        setElementSelected(element);
    }

    function togleNouElement(element: Casal, edit: boolean, duplica: boolean) {
        setNouElement(!nouElement);
        setEditar(edit);
        const modified: Casal = {
            ...element,
            inici: dayjs(element.inici),
            fin: dayjs(element.fin),
            id: duplica ? 0 : element.id
        };
        setElementSelected(modified);
    }

    function handleCloseModal(value: boolean) {
        setNouElement(false);
        if (value) toast.success("GUARDAT");
        else toast.error("NO GUARDAT");
        checkDades();
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: Casal[]) {
        const ingredientNames = elements.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        setNomFiltres(ingredientNames);
    }

    /**
     * FILTRES
     **/

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };


    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };


    /**
     * --- FILTRES ----
     **/


    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);
    const ref5 = useRef(null);
    const ref6 = useRef(null);
    const ref7 = useRef(null);
    const ref8 = useRef(null);
    const steps: TourProps['steps'] = [
        {
            title: 'Crear/Copiar Configuració Casal',
            description: 'Pots crear una nova configuració de Casal prement aquest botó, Tot i que es recomana fer una copia d\'un existent.\n ' +
                'Abans de crear la configuració d\'un casal, cal crear l\'Activitat',
            target: () => ref1.current,
        },
        {
            title: 'Omple la informació',
            description: 'Omple tots els camps del casal. Si no té escoles alternatives d\'entrada deixa-ho en blanc o omple només les que corresponguin..',
            target: () => ref2.current,
        },
        {
            title: 'Activitat',
            description: 'Tria l\'Activitat creada previament. IMPORTANT: Només es poden escollir les activitats en estat "actiu"!!.',
            target: () => ref3.current,
        },
        {
            title: 'Campus',
            description: 'Crea tots els campus que tingui aquesta escola.',
            target: () => ref4?.current
        },
        {
            title: 'Extres',
            description: 'Afegeix tots els extres del casal: Samarreta, tibidabo, etc.. amb el seu preu i descripció.',
            target: () => ref5.current,
        },
        {
            title: 'Opcions de casal',
            description: 'Crea totes les opcions de casal que hi ha (matí, matí i tarda, permanència, acollida, etc...)\n\n ' +
                'Recorda especificar el descompte per setmana quan agafen més d\'una setmana',
            target: () => ref6.current,
        },
        {
            title: 'Crea la configuració del casal',
            description: 'Crea la configuració del casal prement aquest botó.',
            target: () => ref7.current,
        },
        {
            title: 'IMPORTANT',
            description: 'RECORDA: Cal crear una configuració de Casal per cada Casal, es a dir, per cada Escola. Un cop feta la primera' +
                'amb tots els preus, es pot duplicar per no haber d\'introduïr un altre cop tots els preus als altres casals.',
            target: () => ref8.current,
            onFinish: () => {
                afegirElement(new Casal());
                setOpen(false);
            }
        },
    ];

    function tour(b: boolean) {
        afegirElement(new Casal());
        setOpen(b);
    }

    const columns: ColumnsType<Casal> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            sortOrder: 'descend',
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    {permisosEdicio && (
                        <>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                                    onClick={() => togleNouElement(ele, true, false)}><BiPencil/></Button>
                            {" "}
                            <Popconfirm
                                title="Eliminant"
                                description="Vols eliminar definitivament aquest element?"
                                onConfirm={() => deleteElement(ele.id)}
                                icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                            >
                                <Button title={"Eliminar"}
                                        style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                            </Popconfirm>
                            {" "}
                            <Popconfirm
                                title="Duplicar"
                                description="Vols fer una duplica d'aquest casal? Podràs modificar tot el que vulguis."
                                onConfirm={() => togleNouElement(ele, true, true)}
                                icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                            >
                                <Button title={"Duplicar"} ref={ref2}
                                        style={{backgroundColor: Colors.colors.color4}}><BiCopy/></Button>
                            </Popconfirm>
                            {" "}
                        </>
                    )}
                    <Button title={"Mostrar"} onClick={() => togleNouElement(ele, false, false)}
                            style={{backgroundColor: Colors.colors.color3}}><BsEye/></Button>
                </>
            ),
        },
    ];

    const tableProps: TableProps<Casal> = {
        loading
    };

    const onChange: TableProps<Casal>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender2 = (ele: Casal) => {
        return (
            <PlantillaLista element={ele}/>
        );
    };

    async function handleDownload(id: string) {
        setLoading(true);
        //const documentUrl = await GetComandesGeneradesIdPdf(page, id);
        const documentUrl = ""; //TODO: delete

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(true);
    };

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            {permisosEdicio &&
                                <Button title={"Afegir"} ref={ref1} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElement(new Casal())}><BiPlus/></Button>
                            }
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                            <Button title={"Informació"} style={{backgroundColor: Colors.colors.color5}} onClick={() =>
                                tour(true)}><BiInfoCircle/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                columns={columns}
                                /*expandable={{
                                    expandedRowRender: (record) =>
                                        expandedRowRender2(record),
                                    rowExpandable: (record) => true,

                                }}*/
                                dataSource={coleccio}
                            />
                        )}
                    </Card>
                    <br/>
                    <Tour open={open} onClose={() => setOpen(false)} steps={steps} />
                    <Historials pantalla={"CONFIGURACIOCASALS"} pagina={page}/>
                    {nouElement && (
                        <CasalsModal element={elementSelected} onClose={handleCloseModal} visible={nouElement}
                                     ref1={ref1} ref2={ref2} ref3={ref3} ref4={ref4} ref5={ref5} ref6={ref6} ref7={ref7} ref8={ref8}
                                     editar={editar}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default ConfiguracioCasals;
